import { render } from "./MediaUpload.vue?vue&type=template&id=2a868889"
import script from "./MediaUpload.vue?vue&type=script&lang=js"
export * from "./MediaUpload.vue?vue&type=script&lang=js"

import "./MediaUpload.vue?vue&type=style&index=0&id=2a868889&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__